export const ConversionUnit = {
    Millimetre: "mm",
    Centimetre: "cm",
    Metre: "m",
    Default: "Default"
} as const;
export type ConversionUnitType =
    (typeof ConversionUnit)[keyof typeof ConversionUnit];

export const toUnitRangeUnit = (unit: string) =>
    Object.values(ConversionUnit).find(
        (unitRangeUnit) => unitRangeUnit === unit
    ) ?? ConversionUnit.Default;

// LENGTH UNITS
export const MINIMUM_PARTITION_THRESHOLD = 50;
export const DEFAULT_UNIT = ConversionUnit.Centimetre;

const lengthUnits = [
    ConversionUnit.Millimetre,
    ConversionUnit.Centimetre,
    ConversionUnit.Metre
];
export const isLengthUnit = (unit: ConversionUnitType | string) =>
    lengthUnits.find((lengthUnit) => lengthUnit === unit);

const conversionFactors: Partial<Record<ConversionUnitType, number>> = {
    [ConversionUnit.Millimetre]: 1,
    [ConversionUnit.Centimetre]: 10,
    [ConversionUnit.Metre]: 1000
};
const getConversionFactor = (unit: ConversionUnitType) =>
    conversionFactors[unit] ?? 1;

export const convert = (
    value: number,
    fromUnit: ConversionUnitType,
    toUnit: ConversionUnitType
) => (value * getConversionFactor(fromUnit)) / getConversionFactor(toUnit);

const lengthUnitPreferences: Array<{
    condition: (value: number) => boolean;
    unit: ConversionUnitType;
}> = [
    {
        condition: (value) => value < 100,
        unit: ConversionUnit.Millimetre
    },
    {
        condition: (value) => value >= 100 && value < 1000,
        unit: ConversionUnit.Centimetre
    },
    {
        condition: (value) => value >= 1000,
        unit: ConversionUnit.Metre
    }
];
export const getPreferredUnitForValue = (
    value: number,
    unit: ConversionUnitType | string
) =>
    isLengthUnit(unit)
        ? (lengthUnitPreferences.find((unitCondition) =>
              unitCondition.condition(value)
          )?.unit ?? ConversionUnit.Millimetre)
        : ConversionUnit.Default;
